import type { PropsWithChildren } from 'react';

import {
  CardContentStyled,
  type ICardContentStyled,
} from './styles/CardContentStyled'

export interface ICardContent extends ICardContentStyled {}

export const CardContent = ({
  children,
  ...props
}: PropsWithChildren<ICardContent>) => (
  <CardContentStyled {...props}>{children}</CardContentStyled>
)

CardContent.displayName = 'CardContent'
